import { createSlice } from '@reduxjs/toolkit';

const SnackBarSlice = createSlice({
  name: 'snackbar',
  initialState: {
    errorMessages: [],
  },
  reducers: {
    // Error messages
    addNotification: (state, action) => {
      const payload = action.payload;
      // Replace duplicate messages (same newMsg) instead of stacking - keeps toast at top with refreshed timer
      const duplicateIndex = state.errorMessages.findIndex(
        (msg) => msg.newMsg === payload.newMsg && msg.success === payload.success
      );
      if (duplicateIndex !== -1) {
        state.errorMessages.splice(duplicateIndex, 1);
      }
      state.errorMessages.push(payload);
    },
    removeNotification: (state, action) => {
      state.errorMessages = state.errorMessages.filter(
        (msg) => msg.id !== action.payload
      );
    },
    clearNotifications: (state) => {
      state.errorMessages = [];
    },
  },
});

export const {
  addNotification,
  removeNotification,
  clearNotifications,
} = SnackBarSlice.actions;

export default SnackBarSlice.reducer;
